import React from 'react'
import { Link, List, ListItem, Paper, Typography } from '@mui/material'
import FormContact from './FormContact'

import chairBg from '../../media/chairBg.svg'
import Button from '../atoms/Button'
import BlocBorderLeft from './BlocBorderLeft'

const BodyHeader = ({
	title,
	list,
	hasContactForm,
	children,
	buttonLabel,
	infoLabel1,
	infoLabel2,
	buttonHref,
}) => {
	return (
		//TODO: list cliquable
		<>
			<Paper
				sx={(theme) => ({
					position: 'relative',
					bgcolor: 'text.primary',
					borderRadius: 0,
					textAlign: 'left',
					p: (theme) => theme.spacing(13, 14),
					backgroundImage: `url(${chairBg})`,
					backgroundRepeat: 'no-repeat',
					backgroundPosition: '2rem 2rem',

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(5, 3),
						backgroundPosition: theme.spacing(-2, 1),
						backgroundSize: 117,
					},
				})}
			>
				<Typography
					variant="h2"
					sx={(theme) => ({
						[theme.breakpoints.down('md')]: {
							fontSize: 24,
							fontWeight: 800,
							mt: 0,
						},
					})}
				>
					{title}
				</Typography>
				<Typography
					sx={(theme) => ({
						color: 'white',
						fontSize: 18,
						fontWeight: 600,
						textAlign: 'left',
						mt: 2,
						mr: 80,
						[theme.breakpoints.down('md')]: {
							m: 0,
							mt: 2,
							fontSize: 16,
						},
						'& .wpforms-container': {
							borderRadius: 30,
							bgcolor: 'transparent',
							overflow: 'visible',

							[theme.breakpoints.down('md')]: {
								alignItems: 'baseline',
							},

							'& form': {
								bgcolor: 'white',
								position: 'absolute',
								width: 486,
								top: 100,
								right: 100,
								justifyContent: 'center',
								boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.25)',
								pt: 10,
								pb: 4,

								px: 4,

								'& fieldset': {
									borderRadius: 0,
								},

								'& .MuiGrid-item': {
									pb: 2,
								},

								borderRadius: 0.3,
								[theme.breakpoints.down('md')]: {
									position: 'relative',
									width: '100%',
									right: 0,
									left: 0,
									m: theme.spacing(2, 'auto'),
									bottom: -10,
								},
							},
						},
					})}
					dangerouslySetInnerHTML={{ __html: children }}
				/>
				{buttonLabel && (
					<Button color="white" bgColor="green" label={buttonLabel} href={buttonHref || ''} />
				)}
				{infoLabel1 && (
					<BlocBorderLeft info1={infoLabel1} info2={infoLabel2} color="white" ml="0" />
				)}
				{list && (
					<List
						spacing={3}
						sx={(theme) => ({
							display: 'flex',
							flexDirection: 'row',
							m: (theme) => theme.spacing(3, 0, 0),
							justifyContent: 'start',
							[theme.breakpoints.down('md')]: {
								flexWrap: 'wrap',
							},
						})}
					>
						{list.map(({ date, type, slug, id }) => (
							<ListItem
								key={id}
								sx={(theme) => ({
									bgcolor: 'primary.main',
									display: 'table',
									fontSize: 14,
									fontWeight: 700,
									mr: 2,
									width: 'auto',
									[theme.breakpoints.down('md')]: {
										fontSize: 12,
										mb: 2,
									},
									'& a': {
										color: 'black',
									},
								})}
							>
								<Link href={`#${date || slug}`} underline="none">
									{date || type}
								</Link>
							</ListItem>
						))}
					</List>
				)}
				{hasContactForm && <FormContact />}
			</Paper>
		</>
	)
}

export default BodyHeader
